import { ApiType } from '../ApiClient/ApiClient.types';

export const ApiPaths = {
  [ApiType.apimFormApi]: {
    forms: {
      submit: 'forms/submit',
      validate: 'forms/validate',
    },
    dynamicForm: 'dynamic-form',
    dynamicFormValidate: 'dynamic-form/validate',
  },
  [ApiType.apimMotorApi]: {
    // Based on the codebase, this API exists but I didn't find specific usage patterns
    // Keeping minimal structure for potential future use
  },
  [ApiType.apimNafNoApi]: {
    newsfeed: {
      get: (id: string) => `newsfeed/${id}`,
      older: (id: string) => `newsfeed/${id}/older`,
    },
    qnafeed: {
      more: (id: string) => `qnafeed/${id}/more`,
      new: (id: string) => `qnafeed/${id}/new`,
      ask: (id: string) => `qnafeed/${id}/ask`,
    },
    articles: {
      get: (slug: string) => `articles/${slug}`,
      list: 'articles',
    },
    documents: {
      get: (slug: string) => `commonarticles/${slug}`,
    },
    sitestructure: {
      get: (slug: string) => `sitestructure/${slug}`,
      category: {
        app: (slug: string, app: string) => `sitestructure/category/${slug}/app/${app}`,
      },
    },
    frontpage: 'frontpage',
    globalSettings: 'global-settings',
    faq: 'faq',
    benefits: {
      list: 'benefits',
      favorite: (id: string) => `benefits/${id}/favorite`,
    },
    nafLocations: {
      search: (search: string) => `naf-locations/${search}`,
    },
    nafEvents: {
      list: (organizer?: string) => `naf-locations/events${organizer ? `/${organizer}` : ''}`,
    },
    nafCenters: 'naf-centers',
    nafCentersProducts: 'naf-centers/products',
    nafCentersOilChange: (licensePlate: string) => `naf-centers/oilchange/${licensePlate}`,
    nafCentersWindshieldWiper: (licensePlate: string) => `naf-centers/windshield/${licensePlate}`,
    mynaf: {
      get: (id: string) => `mynaf/${id}`,
    },
    ifkcountries: 'ifkcountries',
    consumertest: {
      guides: 'consumertest/guides',
    },
    travelSuggestions: 'travel-suggestions',
    travelSuggestionsRegions: 'travel-suggestions/regions',
    component: {
      get: (id: string) => `component/${id}`,
    },
    polls: {
      answers: (pollId: string) => `polls/${pollId}/submit-answer`,
    },
    competitions: {
      entries: (competitionId: string) => `competitions/${competitionId}/submit-answer`,
    },
    vehicleInspection: (licensePlate: string) => `vehicle-inspection/${licensePlate}`,
    plateNumber: 'plate-number',
    qr: (qrId: string) => `qr/${qrId}`,
  },
  [ApiType.apimVehicleDataApi]: {
    models: 'models',
    modelsearcharguments: 'modelsearcharguments',
  },
  [ApiType.apimMembershipApi]: {
    profile: 'profile',
    profileMembershipRecognition: 'profile/membership-recognition',
    email: 'email',
    addEmail: 'addemail',
    validateEmail: 'profile/validateemail',
    raiseChallengeEvent: 'raisechallenge-event',
    v2: {
      products: 'v2/products',
      productsPayment: 'v2/products/payment',
      productsPaymentValidate: 'v2/products/payment/validate',
      productsActivation: 'v2/products/activation',
      productsUpdate: 'v2/products/update',
      productsLoginPayment: 'v2/products/login/payment',
      productsPaymentOrchestration: (orchestrationId: string) => `v2/products/payment/${orchestrationId}`,
      productsPaymentCanceledDetails: (orchestrationId: string) => `v2/products/payment/${orchestrationId}/canceled`,
      productsActivationOrchestration: (orchestrationId: string) => `v2/products/activation/${orchestrationId}`,
      productsUpdateOrchestration: (orchestrationId: string) => `v2/products/update/${orchestrationId}`,
    },
    householdMembers: 'household-members',
    householdMembersProfile: (id: string) => `household-members/${id}/profile`,
    invoices: 'invoices',
    invoicesPay: 'invoices/pay',
    invoicesPayOrchestration: (paymentId: string) => `invoices/pay/${paymentId}`,
    documents: 'documents',
    personalInformation: 'personalinformation',
    startChallenge: 'start-challenge',
    membership: 'membership',
    membershipCertificate: 'membership-certificate',
    messages: 'messages',
    vehicles: 'vehicles',
    vehiclesDelete: (id: string) => `vehicles/${id}`,
    vehiclesSearch: (licensePlate: string) => `vehicles/${licensePlate}`,
    vehiclesRegister: (licensePlate: string) => `vehicles/${licensePlate}`,
    vehicleMileage: (licensePlate: string) => `vehicles/${licensePlate}/mileage`,
    vehicleAlerts: 'vehicleAlerts',
    upsertVehicleAlerts: (licensePlate: string) => `upsertVehicleAlerts/${licensePlate}`,
    surveys: (surveyId: string) => `surveys/${surveyId}`,
    address: {
      cityName: 'address/city-name',
    },
    consents: {
      customer: 'consents/customer',
      newMember: 'consents/new-member',
    },
  },
  [ApiType.apimNafCenterApi]: {
    bookings: 'bookings',
    serviceCalculator: {
      offer: 'service-calculator/offer',
      offerWithEq: 'service-calculator/offer-with-eq',
      offerSelectedWorkProposal: 'service-calculator/offer-selected-work-proposal',
    },
  },
  [ApiType.apimTravelApi]: {
    travel: {
      routes: {
        delete: (id: string) => `travel/routes/${id}`,
      },
    },
  },
  [ApiType.apimMapsApi]: {
    routes: {
      compute: 'v1/routes/compute',
    },
  },
  [ApiType.elasticSearchAPI]: {
    search: 'search',
  },
};
